import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carousel-index',
  templateUrl: './carousel-index.component.html',
  styleUrls: ['./carousel-index.component.css']
})
export class CarouselIndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $(document).ready(function () {
      $('.carousel').carousel({
       // interval: 2000
      });
    })
  }
}
